






import VueOptions from '@utils/VueOptions'

settings = 
  name: 'Step'
  vue:
    props: ['activeStep', 'name']
    methods:
      back: -> 
        @wizard.back()
      next: -> 
        @wizard.next()

export default VueOptions.vue settings
